<template>
    <header class="header t-blue">
        <router-link :to="'/'">
            <img class="header__logo" alt="Education Cloud Logo" src="../assets/logo.png">
        </router-link>
        <nav class="header__nav">
            <div class="header__mobileButton" @click="toggleMobileNav()">
                <i class="fas fa-bars"></i>
            </div>
            <div class="header__links">
                <router-link :to="'/configurator'" exact>{{ $t('Configurator') }}</router-link>
                <router-link :to="'/questions'" exact>{{ $t('Questions') }}</router-link>
                <router-link :to="'/glossary'" exact>{{ $t('Glossary') }}</router-link>
                <router-link :to="'/about'" exact>{{ $t('About us') }}</router-link>
            </div>
        </nav>
        <div class="mobile_links" @click="closeMobileNav()" :class="{open: mobileNavIsOpen}">
            <router-link :to="'/configurator'" exact>{{ $t('Configurator') }}</router-link>
            <router-link :to="'/questions'" exact>{{ $t('Questions') }}</router-link>
            <router-link :to="'/glossary'" exact>{{ $t('Glossary') }}</router-link>
            <router-link :to="'/about'" exact>{{ $t('About us') }}</router-link>
        </div>
        <div class="header__lang">
        </div>
        <div class="header__lang" id="responsive_lang">
        </div>
    </header>
</template>

<script>
    export default {
        data(){
            return {
                mobileNavIsOpen: false,
                languageText: {
                    "ch": "<p>Lehrplan 21<br>(Deutsch)</p>",
                    "de": "<p>DigitalPakt Schule<br>(Deutsch)</p>"
                },
                languageIcon: {
                    "ch": "ch.png",
                    "de": "de.png"
                }
            }
        },
        computed: {
            currentLanguage() {
                return "de"
            }
        },
        methods: {
            toggleMobileNav(){
                this.mobileNavIsOpen = !this.mobileNavIsOpen
            },
            closeMobileNav(){
                this.mobileNavIsOpen = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .header {
        //position: relative;
        display: flex;
        width: 100%;
        padding: 30px 0px 30px 60px;
        justify-content: space-between;
        overflow: hidden;
        background-image: url("~@/assets/cloud.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right;

        &__logo {
            height: 90px;
        }

        &__nav {
            z-index: 10;
            align-self: flex-end;
            a {
                text-decoration: none;
                font-size: 20px;
                margin: 0 35px;
                transition: color linear 0.2s;
            }
            a:hover, .router-link-active {
                color: $orange;
            }
        }

        &__mobileButton {
            display: none;
        }
        .mobile_links {
            opacity: 0;
            background-color: $orange;
            width: 100%;
            position: fixed;
            z-index: 999999999;
            left: 0;
            top: 134px;
            height: auto;
            transition: .5s all ease;
            display: none;
        }

        .header__lang {
            padding-right: 50px;

            .current_lang {
                text-align: center;
                font-weight: 700;

                .language__flag {
                    width: 40px;
                    height: 40px;
                    background-size: cover;
                    border-radius: 100px;
                    margin: 0 auto;
                }
            }
            .lang_list {
                display: none;
                position: absolute;
                background-color: $blue;
                right: 0px;
                top: 165px;
                width: 500px;
                padding: 60px 20px 0px 20px;
                z-index: 999;

                .language {
                    display: block;
                    position: relative;
                    padding: 8px 80px;
                    width: 100%;
                    border: 1px solid $white;
                    margin-bottom: 25px;
                    font-size: 20px;
                    color: $white;
                    text-decoration: none;
                    font-weight: 400;
                    transition: 0.2s all ease;

                    i {
                        position: absolute;
                        right: 20px;
                        top: 6px;
                        font-size: 54px;
                    }

                    &__flag {
                        width: 36px;
                        height: 36px;
                        border-radius: 100px;
                        background-size: cover;
                        background-position: center;
                        position: absolute;
                        top: 16px;
                        left: 20px;
                    }
                }

                .language:hover {
                    background-color: $white;
                    color: $blue;
                }
            }
        }

        #responsive_lang {
            display: none;
        }

        .header__lang:hover{
            .lang_list {
                display: block;
            }
        }
    }

    @media (max-width: 1620px){
        .header__logo {
            height: 70px;
        }
        .header__nav a {
            margin: 0 10px;
        }
    }

    @media (max-width: 1190px){
        .header {
            display: block;
            background-size: cover;
            position: fixed;
            z-index: 999;

            .header__lang {
                display: none;
            }

            #responsive_lang {
                display: block;
                position: absolute;
                top: 45px;
                right: 80px;

                .lang_list {
                    width: 100%;
                    top: 89px;
                }
            }

            #responsive_lang:hover {
                .current_lang {
                    padding-bottom: 30px;
                }

                .lang_list {
                    display: block;
                    position:fixed;
                    top: 134px;
                }
            }
        }
        .header__nav {
          position: absolute;
          right: 50px;
          top: 30px;
        }
        .header__nav a {
            display: block;
            margin: 10px 0;
        }
        .header__mobileButton {
            display: block;
            font-size: 30px;
            margin-top: 20px;
            cursor: pointer;
        }
        .header__links {
            margin-top: 30px;
            display: none;
            position: absolute;
            background-color: $blue;
        }
        .header__links.open {
            display: block
        }
        .mobile_links.open {
            opacity: 1;
            display: block
        }
        .mobile_links a {
            display: block;
            padding: 15px 0;
            text-decoration: none;
            text-align: center;
        }
        .mobile_links a:hover {
          background-color: rgba(255,255,255,0.1);
        }
    }

    @media (max-width: 500px) {
        .header {
            padding: 30px 0px 30px 15px;
        }
    }

    @media (max-width: 440px) {
        .header__logo {
            width: 125px;
            height: auto;
        }
        .header__nav {
            top: 15px;
        }
        .header #responsive_lang {
            top: 27px;
        }
        .header #responsive_lang:hover .lang_list {
            top: 104px;
        }
        .header .mobile_links {
            top: 104px;
        }
    }
</style>
